
import StencilHTMLElement from "./stencil-element";

class WallpanelCalculator extends StencilHTMLElement {
  name = "WallpanelCalculator";
  widthInput;
  quantityRequired;
  calculateButton;
  calculatorInputs;
  recalculateButton;
  calculatorCard;
  calculatorResult;
  resultCard;
  panelHeightInputs;
  panelHeightResults;
  
  constructor() {
    super();

    this.calculateButton = this.querySelector(".calculate-button");
    this.widthInput = this.querySelector(".width-input");
    this.quantityRequired = this.querySelector(".quantity-required");
    this.calculatorInputs = this.querySelector(".calculator-inputs");
    this.recalculateButton = this.querySelector(".recalculate-button");
    this.calculatorCard = this.querySelector(".calculator-card"); 
    this.calculatorResult = this.querySelector(".calculator-result");
    this.resultCard = this.querySelector(".result-panel");

    this.calculateButton.addEventListener("click", this.calculatePanels.bind(this));
    this.recalculateButton.addEventListener("click", this.hideResultsPanel.bind(this));

    this.panelHeightInputs = this.calculatorCard.offsetHeight;
    this.panelHeightResults = this.resultCard.offsetHeight;

  }

  calculatePanels() {
    const maxPanelWidth = parseFloat(this.calculateButton.dataset.variantWallpanelWidth) || 1200;
    const inputValue = parseFloat(this.widthInput.value) || 0;

    this.calculatorCard.style.height = `${this.panelHeightResults}px`;

    if (inputValue > 0) {
      const numberOfPanels = Math.ceil(inputValue / maxPanelWidth);
      this.quantityRequired.textContent = numberOfPanels;

      this.toggleCalculatorState(true); 
    }
  }

  hideResultsPanel() {
    this.quantityRequired.textContent = 0;
    this.calculatorCard.style.height = `${this.panelHeightInputs}px`;

    this.toggleCalculatorState(false); 
  }

  toggleCalculatorState(showResult) {
    this.calculatorResult.classList.toggle("active", showResult);
    this.calculatorResult.classList.toggle("hidden", !showResult);
    this.calculatorInputs.classList.toggle("active", !showResult);
    this.calculatorInputs.classList.toggle("hidden", showResult);
  }
}

export default WallpanelCalculator;
